module.exports = "/images/vendor/flag-icon-css/flags/4x3/gg.svg?98f67a6ff36afda7a5ec44ec59eb5033";